import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  IconButton,
  Typography,
  Box,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  Stack,
  useThemeProps,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormLabel,
} from "@mui/material";
import Logo from "../../../assets/images/common/chat-logo.png";
import { useTheme } from "@mui/material/styles";
import {
  Newchat,
  Dropdown,
  Gemini,
  Chatlike,
  Chatdislike,
  Chatrefresh,
  Chatcopy,
  Sendmessege,
  Modalclose,
  Hamburguricon,
  Editbtn,
} from "../../../icons/icons";
import Link from "@mui/material/Link";
import Autocomplete from "@mui/material/Autocomplete";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid2";
import { useDispatch, useSelector } from "react-redux";
import { ModelSelection, Selectedchatbot } from "../../../redux/chatslice";
import Indiaflag from "../../../assets/images/login/india-flag.svg";
import Chatgpt from "../../../assets/images/common/chatgpt-logo.png";
import Geminilogo from "../../../assets/images/common/gemini-logo.png";
import Gemma from "../../../assets/images/common/gemma-logo.png";
import Mistral from "../../../assets/images/common/mistral-logo.png";
import Websearch from "../../../assets/images/common/web-search-logo.png";
import { Visibility, VisibilityOff } from "@mui/icons-material";

import Tick from "../../../assets/images/common/tick-icon.png";
import {
  ChangePassword,
  Getprofile,
  Updateprofile,
  resetLogin,
} from "../../../redux/authSlice";
import { decryptUserId } from "../../../utilis/encrypto";
import { ModelReselect } from "../../../redux/chatslice";
import PhoneInput from "react-phone-input-2";
import { updateSidebarSelection } from "../../../redux/sidebarreducer";

// import base_url from "../../../commanimage";
import { base_url } from "../../../constant";
function Myaccount({ onClear }) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { model } = useSelector((state) => state.chat);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [showPasswordChange, setShowPasswordChange] = useState(false);
  const [editing, setEditing] = useState(false);
  const [profile, setProfile] = useState({
    name: "",
    email: "",
    phone_number: "",
  });
  const [validationErrors, setValidationErrors] = useState({
    name: "",
    email: "",
    phone_number: "",
  });
  const { getprofile } = useSelector((state) => state.admin);
  const [current_password, setPassword] = useState("");
  const [movedToUnselected, setMovedToUnselected] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  // console.log(selectedItems, "selectedItems");
  const [new_password, setnewPassword] = useState("");
  const [confirm_password, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showconfirmPassword, setShowconfirmPassword] = useState(false);
  const [shownewPassword, setShownewPassword] = useState(false);
  const [textGeneration, setTextGeneration] = useState();
  const [imageGeneration, setImageGeneration] = useState();
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleClicknewPassword = () => setShownewPassword(!shownewPassword);
  const handleClickconfirmPassword = () =>
    setShowconfirmPassword(!showconfirmPassword);
  // console.log(textGeneration, "textGenerationtextGeneration");
  // Determine default selection based on selected items, with safety checks
  const defaultSelection = textGeneration?.some((item) => item.isSelected)
    ? "Text"
    : imageGeneration?.some((item) => item.isSelected)
    ? "Image"
    : "Text";

  const [selectedOption, setSelectedOption] = useState(defaultSelection);
  // console.log(selectedOption, "first");
  // useEffect(() => {
  //   if (model.text_model?.length > 0) setTextGeneration(model.text_model);
  //   if (model.image_model?.length > 0) setImageGeneration(model.image_model);
  //   if (model.text_model?.length > 0) {
  //     const initiallySelected = model.text_model.filter(
  //       (item) => item.isSelected
  //     );
  //     setSelectedItems(initiallySelected);
  //   }
  // }, [model]);
  useEffect(() => {
    setSelectedOption(defaultSelection);
  }, [selectedItems, defaultSelection]);

  const validatePassword = () => {
    const errors = {};
    if (!current_password)
      errors.current_password = "Current password is required.";
    if (!new_password) errors.new_password = "New password is required.";
    if (new_password !== confirm_password)
      errors.confirm_password = "Passwords do not match.";
    if (new_password.length < 8)
      errors.new_password = "Password must be at least 6 characters long.";
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };
  useEffect(() => {
    if (getprofile?.social_id === null) {
      setShowPasswordChange(true);
    } else {
      setShowPasswordChange(false);
    }
  }, [getprofile?.social_id]);
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validatePassword()) {
      try {
        await dispatch(
          ChangePassword({ current_password, new_password, confirm_password })
        );
        dispatch(resetLogin());

        setPassword("");
        setnewPassword("");
        setConfirmPassword("");

        await dispatch(Getprofile());
      } catch (error) {
        setError("Failed to update password.");
      }
    } else {
      // Handle validation errors
    }
  };
  useEffect(() => {
    const getProfile = async () => {
      try {
        await dispatch(Getprofile());
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    getProfile();
  }, [dispatch]);

  useEffect(() => {
    if (getprofile) {
      setProfile({
        name: getprofile.name,
        email: getprofile.email || "",
        phone_number: getprofile.phone_number || "",
        country_code: getprofile.country_code || "+91",
      });
    }
  }, [getprofile]);
  const validateFields = () => {
    const errors = {};

    if (!profile.name.trim()) errors.name = "Name is required.";
    if (!profile.email.trim()) errors.email = "Email is required.";
    // if (!profile.phone_number.trim())
    //   errors.phone_number = "Phone number is required.";

    setValidationErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handlePhoneChange = (phone, data) => {
    const countryCodeLength = data.dialCode.length;
    const actualPhoneNumber = phone.substring(countryCodeLength);

    setProfile((prevFormData) => ({
      ...prevFormData,
      country_code: data.dialCode, // Country code will be stored here
      phone_number: actualPhoneNumber, // Actual phone number here
    }));
  };

  const handleEditToggle = () => {
    setIsEditing((prev) => !prev);
  };
  useEffect(() => {
    dispatch(ModelSelection());
  }, [dispatch]);
  useEffect(() => {
    if (model.text_model?.length > 0) {
      setTextGeneration(model.text_model);
    }
  }, [model.text_model]);
  useEffect(() => {
    if (model.image_model?.length > 0) {
      setImageGeneration(model.image_model);
    }
  }, [model.image_model]);

  const handleSave = async (e) => {
    e.preventDefault();

    const updatedFields = Object.keys(profile).reduce((acc, key) => {
      if (profile[key] !== getprofile[key]) {
        acc[key] = profile[key];
      }
      return acc;
    }, {});

    if (Object.keys(updatedFields).length === 0) {
      // No changes detected
      setIsEditing(false);
      return;
    }

    try {
      await dispatch(Updateprofile(updatedFields));
      dispatch(Getprofile());
      setIsEditing(false);
    } catch (error) {
      // Handle error (e.g., show an error message)
    }
  };
  // const handleSave = async (e) => {
  //   e.preventDefault();

  //   if (validateFields()) {
  //     const updatedFields = Object.keys(profile).reduce((acc, key) => {
  //       if (profile[key] !== getprofile[key]) {
  //         acc[key] = profile[key];
  //       }
  //       return acc;
  //     }, {});

  //     if (Object.keys(updatedFields).length === 0) {
  //       // console.log("No changes detected.");
  //       setIsEditing(false);
  //       return;
  //     }

  //     try {
  //       await dispatch(Updateprofile(updatedFields));
  //       dispatch(Getprofile())
  //       setIsEditing(false);
  //     } catch (error) {
  //       // console.error("Failed to update profile:", error);
  //     }
  //   } else {
  //     // console.log("Please enter valid data.");
  //   }
  // };


  useEffect(() => {
    let initiallySelected = [];

    if (model.text_model?.length > 0) {
      setTextGeneration(model.text_model);
      // console.log(model.text_model, "jj");
      initiallySelected = model.text_model.filter((item) => item.isSelected);
    }

    if (model.image_model?.length > 0) {
      setImageGeneration(model.image_model);
      let data = model.image_model.filter((item) => item.isSelected);
      if (data.length > 0) {
        initiallySelected = data;
      }
    }
    // console.log(initiallySelected, "  asjdlakjl");
    setSelectedItems(initiallySelected);
  }, [model]);
  // useEffect(() => {}, [model]);

  const handleEditselect = () => {
    setEditing((prev) => !prev);
  };
  const toggleSelection = (id, generationArray, setGenerationArray) => {
    const elementBeforeToggle = generationArray.find((el) => el.id === id);

    const updatedState = generationArray.map((element) =>
      element.id === id
        ? { ...element, isSelected: !element.isSelected }
        : element
    );

    setGenerationArray(updatedState);

    if (elementBeforeToggle.isSelected) {
      const movedItem = { ...elementBeforeToggle, isSelected: false };
      setMovedToUnselected((prev) => [...prev, movedItem]);
    } else {
      setMovedToUnselected((prev) => prev.filter((item) => item.id !== id));
    }

    const currentlySelectedItems = updatedState.filter(
      (item) => item.isSelected
    );
    setSelectedItems(currentlySelectedItems);
  };

  const handleActive = (id) => {
    toggleSelection(id, textGeneration, setTextGeneration);
  };

  const handleActiveImage = (id) => {
    toggleSelection(id, imageGeneration, setImageGeneration);
  };

  const handleRadioChange = (event) => {
    const newSelection = event.target.value;
    setSelectedOption(newSelection);

    if (newSelection === "Text") {
      // Move selected image items to unselected before clearing selection
      setMovedToUnselected((prev) => [
        ...prev,
        ...imageGeneration.filter((item) => item.isSelected),
      ]);

      // Deselect all items in imageGeneration
      setImageGeneration((prevImageGeneration) =>
        prevImageGeneration.map((item) => ({ ...item, isSelected: false }))
      );
    } else {
      // Move selected text items to unselected before clearing selection
      setMovedToUnselected((prev) => [
        ...prev,
        ...textGeneration.filter((item) => item.isSelected),
      ]);

      // Deselect all items in textGeneration
      setTextGeneration((prevTextGeneration) =>
        prevTextGeneration.map((item) => ({ ...item, isSelected: false }))
      );
    }
    dispatch(updateSidebarSelection(newSelection));
  };

  const handleSelected = () => {
    const encryptedUserId = localStorage.getItem("userId");
    const userId = decryptUserId(encryptedUserId);

    if (!userId) {
      console.error("Failed to decrypt user ID.");
      return;
    }

    const selectedIds = selectedItems.map((item) => item.id.toString());
    const unselectedIds = movedToUnselected.map((item) => item.id.toString());

    const payload = {
      user_id: userId,
      selected: selectedIds,
      unselected: unselectedIds,
    };
    onClear();

    dispatch(ModelReselect(payload));

    setEditing(false);
    setMovedToUnselected([]);
    // window.location.reload();
  };

  return (
    <>
      <Box>
        <Stack
          direction={"row"}
          alignItems={"center"}
          sx={{
            p: { xs: "14px 12px", sm: "16px 32px" },
            borderBottom: "1px solid",
            borderBottomColor: "#0A43AE",
          }}
        >
          <Typography
            variant="h2"
            sx={{
              color: theme.palette.secondary.main,
              fontSize: "20px",
              fontWeight: "700",
            }}
            fullWidth
          >
            My Account
          </Typography>
        </Stack>

        <Box
          sx={{
            borderBottom: "1px solid",
            borderBottomColor: "#0A43AE",
            p: { xs: "14px 12px", sm: "24px 32px" },
          }}
        >
          <Box sx={{ mb: { xs: "8px", sm: "16px" } }}>
            <Typography
              variant="h2"
              sx={{
                color: theme.palette.secondary.main,
                fontSize: "20px",
                fontWeight: "700",
                // ml: "10px",
              }}
              fullWidth
            >
              Personal Info
            </Typography>
          </Box>

          <Grid
            container
            spacing={{ xs: "10px", sm: "20px" }}
            sx={{ height: "100%" }}
          >
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
              <FormControl
                fullWidth
                sx={{
                  height: "100%",
                  mb: { xs: 0, lg: 2 },
                  "& .flag-dropdown": {
                    background: "transparent",
                    borderColor: "transparent",
                  },
                  "& .selected-flag": {
                    paddingLeft: "12px",
                    "&:hover": {
                      background: "transparent",
                    },
                  },
                  "& .flag-dropdown.open": {
                    "& .selected-flag.open": {
                      background: "transparent",
                      borderColor: "transparent",
                    },

                    background: "transparent",
                    borderColor: "transparent",

                    "& .country-list": {
                      background: "#041855",
                      borderColor: "transparent",
                      color: "#fff",
                      "& :hover": {
                        background: "#02297F",
                      },
                    },

                    "& .react-tel-input ": {
                      height: "100%",
                    },
                  },
                }}
              >
                {isEditing ? (
                  <PhoneInput
                    country={"in"}
                    value={profile.country_code + profile.phone_number}
                    onChange={handlePhoneChange}
                    placeholder=""
                    sx={{ height: "100%" }}
                    inputStyle={{
                      color: "#fff",
                      backgroundColor: "transparent",
                      width: "100%",
                      height: "100%",
                      borderRadius: "12px",
                      border: "1px solid #0A43AE",
                      padding: "11px 12px 11px 50px",
                      "& :focus": {
                        boxShadow: "0 0 0 .25rem rgb(13 110 253 / 0%)",
                      },
                    }}
                    buttonStyle={{ color: "#000" }}
                  />
                ) : (
                  <Box
                    sx={{
                      borderRight: { xs: "0px solid", sm: "1px solid" },
                      borderRightColor: { xs: "#0A43AE", sm: "#0A43AE" },
                    }}
                  >
                    <Typography
                      sx={{
                        color: theme.palette.secondary.main,
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    >
                      Mobile No.
                    </Typography>

                    <PhoneInput
                      country={"in"}
                      // country={profile.country_code}
                      value={profile.country_code + profile.phone_number}
                      placeholder=""
                      disabled
                      containerClass="custom-phone-input"
                      inputStyle={{
                        color: "#fff",
                        backgroundColor: "transparent",
                        width: "auto",
                        border: "none",
                        padding: 0,
                        fontSize: "16px",
                        fontWeight: "500",
                        padding: "0 0 0 47px",
                      }}
                      buttonStyle={{
                        backgroundColor: "#fff",
                        border: "none",
                        margin: 0,
                        padding: 0,
                      }}
                    />

                    <Typography
                      sx={{
                        color: "#fff",
                        fontSize: "16px",
                        fontWeight: "500",
                        mt: { xs: "0px", lg: "4px" },
                      }}
                    >
                      {" "}
                    </Typography>
                  </Box>
                )}
                {validationErrors.phone_number && (
                  <Typography color="error" variant="caption">
                    {validationErrors.phone_number}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
              <FormControl
                fullWidth
                sx={{
                  mb: { xs: 0, lg: 2 },
                }}
              >
                {isEditing ? (
                  <OutlinedInput
                    name="name"
                    value={profile.name}
                    onChange={handleChange}
                    sx={{ color: "#fff" }}
                  />
                ) : (
                  <Box
                    sx={{
                      borderRight: { xs: "0px solid", md: "1px solid" },
                      borderRightColor: { xs: "#0A43AE", md: "#0A43AE" },
                      pl: { xs: "0px", sm: "10px", lg: "80px", xl: "80px" },
                    }}
                  >
                    <Typography
                      sx={{
                        color: theme.palette.secondary.main,
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    >
                      Name
                    </Typography>
                    <Typography
                      sx={{
                        color: "#fff",
                        fontSize: "16px",
                        fontWeight: "500",
                        mt: { xs: "0px", lg: "4px" },
                      }}
                    >
                      {profile.name}
                    </Typography>
                  </Box>
                )}
                {validationErrors.name && (
                  <Typography color="error" variant="caption">
                    {validationErrors.name}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
              <FormControl fullWidth sx={{ mb: { xs: 0, lg: 2 } }}>
                {isEditing ? (
                  <OutlinedInput
                    name="email"
                    value={profile.email}
                    onChange={handleChange}
                    sx={{ color: "#fff" }}
                  />
                ) : (
                  <Box
                    sx={{
                      pl: { xs: "0px", md: "10px", lg: "80px", xl: "80px" },
                    }}
                  >
                    <Typography
                      sx={{
                        color: theme.palette.secondary.main,
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    >
                      Email ID
                    </Typography>
                    <Typography
                      sx={{
                        color: "#fff",
                        fontSize: "16px",
                        fontWeight: "500",
                        mt: { xs: "0px", lg: "4px" },
                      }}
                    >
                      {profile.email}
                    </Typography>
                  </Box>
                )}
                {validationErrors.email && (
                  <Typography color="error" variant="caption">
                    {validationErrors.email}
                  </Typography>
                )}
              </FormControl>
            </Grid>
          </Grid>
          <Stack
            justifyContent={"end"}
            alignItems={"center"}
            direction={"row"}
            sx={{ mt: "8px" }}
          >
            {isEditing ? (
              <>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSave}
                  sx={{
                    borderRadius: "50px",
                    p: { xs: "5px 12px", lg: "8px 18px", xl: "8px 18px" },
                    fontSize: "16px",
                    fontWeight: "500",
                    borderRadius: "50px",
                    height: "auto",
                    mr: "10px",
                  }}
                >
                  Save Details
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleEditToggle}
                  sx={{
                    borderRadius: "50px",
                    p: { xs: "5px 12px", lg: "8px 18px", xl: "8px 18px" },
                    fontSize: "16px",
                    fontWeight: "500",
                    borderRadius: "50px",
                    height: "auto",
                  }}
                >
                  Cancel
                </Button>
              </>
            ) : (
              <Button
                variant="contained"
                color="primary"
                onClick={handleEditToggle}
                sx={{
                  borderRadius: "50px",
                  p: { xs: "5px 12px", lg: "8px 18px", xl: "8px 18px" },
                  fontSize: "16px",
                  fontWeight: "500",
                  borderRadius: "50px",
                  height: "auto",
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <Box sx={{ mr: "4px" }}>
                  <Editbtn />
                </Box>
                Edit Details
              </Button>
            )}
          </Stack>
        </Box>
        {showPasswordChange && (
          <Box
            sx={{
              borderBottom: "1px solid",
              borderBottomColor: "#0A43AE",
              p: { xs: "14px 12px", sm: "24px 32px" },
            }}
          >
            <Box sx={{ mb: "16px" }}>
              <Typography
                variant="h2"
                sx={{
                  color: theme.palette.secondary.main,
                  fontSize: "20px",
                  fontWeight: "700",
                }}
                fullWidth
              >
                Change Password
              </Typography>
            </Box>
            <></>
            <Grid container spacing={"16px"} sx={{ height: "100%" }}>
              <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4 }}>
                <FormControl fullWidth sx={{ mb: { xs: 0, lg: 2 } }}>
                  <OutlinedInput
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Current Password"
                    value={current_password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="custom-input"
                    sx={{ color: "#fff" }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickShowPassword}
                          edge="end"
                          sx={{ color: "#fff", paddingRight: "12px" }}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
                {validationErrors.current_password && (
                  <Typography color="error" variant="caption">
                    {validationErrors.current_password}
                  </Typography>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4 }}>
                <FormControl fullWidth sx={{ mb: { xs: 0, lg: 2 } }}>
                  <OutlinedInput
                    type={shownewPassword ? "text" : "password"}
                    name="password"
                    placeholder="New Password"
                    value={new_password}
                    onChange={(e) => setnewPassword(e.target.value)}
                    className="custom-input"
                    sx={{ color: "#fff" }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClicknewPassword}
                          edge="end"
                          sx={{ color: "#fff" }}
                        >
                          {shownewPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
                {validationErrors.new_password && (
                  <Typography color="error" variant="caption">
                    {validationErrors.new_password}
                  </Typography>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4 }}>
                <FormControl fullWidth sx={{ mb: { xs: 0, lg: 2 } }}>
                  <OutlinedInput
                    type={showconfirmPassword ? "text" : "password"}
                    name="password"
                    placeholder="Confirm Password"
                    value={confirm_password}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className="custom-input"
                    sx={{ color: "#fff" }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickconfirmPassword}
                          edge="end"
                          sx={{ color: "#fff" }}
                        >
                          {showconfirmPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
                {validationErrors.confirm_password && (
                  <Typography color="error" variant="caption">
                    {validationErrors.confirm_password}
                  </Typography>
                )}
              </Grid>
            </Grid>
            {error && <p style={{ color: "red" }}>{error}</p>}

            <Stack
              justifyContent={"end"}
              alignItems={"center"}
              direction={"row"}
            >
              <Button
                type="submit"
                variant="contained"
                color="primary"
                sx={{
                  mb: { xs: 0, xl: 2 },
                  p: { xs: "5px 12px", lg: "8px 18px", xl: "8px 18px" },
                  backgroundColor: "primary.Main",
                  fontSize: "16px",
                  fontWeight: "500",
                  borderRadius: "50px",
                  height: "auto",
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                  mt: { xs: 2, lg: 0 },
                }}
                onClick={handleSubmit}
              >
                <Box sx={{ mr: "4px" }}>
                  <Editbtn />
                </Box>
                Update Password
              </Button>
            </Stack>
          </Box>
        )}

        <Box
          sx={{
            p: { xs: "14px 12px", sm: "24px 32px" },
          }}
        >
          <Box sx={{ mb: "16px" }}>
            <Typography
              variant="h2"
              sx={{
                color: theme.palette.secondary.main,
                fontSize: "20px",
                fontWeight: "700",
              }}
              fullWidth
            >
              LLM Preferences
            </Typography>
          </Box>

          {!editing ? (
            <>
              {selectedItems.length > 0 ? (
                <Grid container spacing={3}>
                  {selectedItems.map((item) => (
                    <Grid size={{ xs: 6, md: 2 }} key={item.id}>
                      <Box
                        sx={{
                          width: "100%",
                          height: "100%",
                          background: theme.palette.primary.main,
                          borderRadius: "12px",
                          p: { xs: "16px", lg: "24px 40px" },
                          textAlign: "center",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "relative",
                          border: "1px solid",
                          borderColor: theme.palette.greyshades.grey100,
                        }}
                      >
                        <img
                          src={`${base_url}/${item.image}`}
                          alt="selected-model"
                          style={{ maxWidth: "100%", height: "auto" }}
                        />
                        <Typography>{item.name}</Typography>
                        <Box
                          sx={{
                            position: "absolute",
                            top: "6px",
                            right: "12px",
                          }}
                        >
                          <img src={Tick} alt="tick-icon" />
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Typography>No model selected</Typography>
              )}
            </>
          ) : (
            <Box>
              <FormControl fullWidth>
                <FormLabel id="demo-radio-buttons-group-label"></FormLabel>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="Text"
                  name="radio-buttons-group"
                  value={selectedOption}
                  onChange={handleRadioChange}
                >
                  <Box sx={{ mb: "16px" }}>
                    <FormControlLabel
                      value="Text"
                      control={<Radio />}
                      label="Text Generation"
                      sx={{
                        mb: 1,

                        "& .MuiFormControlLabel-label": {
                          color: theme.palette.secondary.main,
                          fontSize: "18px",
                          fontWeight: "700",
                          ml: "5px",
                        },
                      }}
                    />
                    {/* Text Generation Section */}
                    {selectedOption === "Text" &&
                      textGeneration &&
                      textGeneration.length > 0 && (
                        <Grid container spacing={3}>
                          {textGeneration.map((item) => (
                            <Grid size={{ xs: 6, md: 2 }} key={item.id}>
                              <Box
                                sx={{
                                  width: "100%",
                                  height: "100%",
                                  background: item.isSelected
                                    ? "#0A43AE"
                                    : theme.palette.primary.primary5,
                                  borderRadius: "12px",
                                  border: item.isSelected
                                    ? "1px solid transparent"
                                    : "1px solid #0A43AE",
                                  p: "20px 20px",
                                  textAlign: "center",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  position: "relative",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleActive(item.id)}
                              >
                                <img
                                  src={`${base_url}/${item.image}`}
                                  alt="generated-text-icon"
                                  style={{ maxWidth: "100%", height: "auto" }}
                                />
                                {item.isSelected && (
                                  <Box
                                    sx={{
                                      position: "absolute",
                                      top: "6px",
                                      right: "12px",
                                    }}
                                  >
                                    <img src={Tick} alt="tick-icon" />
                                  </Box>
                                )}
                              </Box>
                            </Grid>
                          ))}
                        </Grid>
                      )}
                  </Box>

                  <Box sx={{ mb: "16px" }}>
                    <FormControlLabel
                      value="Image"
                      control={<Radio />}
                      label="Image Generation"
                      sx={{
                        mb: 1,
                        "& .MuiFormControlLabel-label": {
                          color: theme.palette.secondary.main,
                          fontSize: "18px",
                          fontWeight: "700",
                          ml: "5px",
                        },
                      }}
                    />
                    {/* Image Generation Section */}
                    {selectedOption === "Image" &&
                      imageGeneration &&
                      imageGeneration.length > 0 && (
                        <Grid container spacing={3}>
                          {imageGeneration.map((ele) => (
                            <Grid key={ele.id} size={{ xs: 6, md: 2 }}>
                              <Stack
                                onClick={() => handleActiveImage(ele.id)}
                                justifyContent={"center"}
                                alignItems={"center"}
                                sx={{
                                  width: "100%",
                                  height: "100%",
                                  borderRadius: "12px",
                                  p: "20px 20px",
                                  textAlign: "center",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  position: "relative",
                                  cursor: "pointer",
                                  // background: ele.isSelected
                                  //   ? theme.palette.primary.main
                                  //   : theme.palette.greyshades.grey100,

                                  background: ele.isSelected
                                    ? "#0A43AE"
                                    : theme.palette.primary.primary5,

                                  border: ele.isSelected
                                    ? "1px solid transparent"
                                    : "1px solid #0A43AE",
                                }}
                              >
                                <img
                                  src={`${base_url}/${ele.image}`}
                                  alt="generated-image"
                                  style={{ maxWidth: "100%", height: "auto" }}
                                />
                                {ele.isSelected && (
                                  <Box
                                    sx={{
                                      position: "absolute",
                                      top: "6px",
                                      right: "12px",
                                    }}
                                  >
                                    <img src={Tick} alt="tick-icon" />
                                  </Box>
                                )}
                              </Stack>
                            </Grid>
                          ))}
                        </Grid>
                      )}
                  </Box>
                </RadioGroup>
              </FormControl>
            </Box>
          )}

          {/* <Box sx={{ mb: "16px", mt: "24px" }}>
            <Typography
              variant="h2"
              sx={{
                color: theme.palette.secondary.main,
                fontSize: "20px",
                fontWeight: "700",
                ml: "10px",
              }}
              fullWidth
            >
              Text Generation
            </Typography>
          </Box> */}
          {/* <Grid
            container
            spacing={"16px"}
            sx={{ height: "100%" }}
            columns={{ xs: 4, xl: 7 }}
          >
            <Grid size={{ xs: 2, sm: 1 }}>
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  background: theme.palette.greyshades.grey200,
                  borderRadius: "12px",
                  p: { xs: "16px", lg: "24px 40px" },
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  position: "relative",
                  border: "1px solid",
                  borderColor: theme.palette.greyshades.grey100,
                  "& > .child": {
                    maxWidth: "100%",
                    height: "auto",
                  },
                }}
              >
                <img src={Chatgpt} alt="logo" className="child" />
              </Box>
            </Grid>
          </Grid> */}

          <Stack justifyContent={"end"} alignItems={"center"} direction={"row"}>
            {/* <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{
                mb: { xs: 0, xl: 2 },
                p: { xs: "8px 18px", xl: "8px 18px" },
                backgroundColor: "primary.Main",
                fontSize: "16px",
                fontWeight: "500",
                borderRadius: "50px",
                height: "auto",
              }}
            > */}
            {!editing ? (
              <Button
                variant="contained"
                color="primary"
                sx={{
                  mt: { xs: 1, sm: 0 },
                  mb: { xs: 0, xl: 2 },
                  p: { xs: "8px 18px", xl: "8px 18px" },
                  backgroundColor: "primary.main",
                  fontSize: "16px",
                  fontWeight: "500",
                  borderRadius: "50px",
                  height: "auto",
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
                onClick={handleEditselect}
              >
                <Box sx={{ mr: "4px" }}>
                  <Editbtn />
                </Box>
                Change Preferences
              </Button>
            ) : (
              <>
                <Button
                  type="button"
                  variant="contained"
                  color="primary"
                  sx={{
                    mb: { xs: 0, xl: 2 },
                    p: { xs: "8px 18px", xl: "8px 18px" },
                    backgroundColor: "primary.main",
                    fontSize: "16px",
                    fontWeight: "500",
                    borderRadius: "50px",
                    height: "auto",
                  }}
                  onClick={handleSelected} // Saves preferences
                >
                  Save Preferences
                </Button>
                <Button
                  type="button" // Avoid submitting form here
                  variant="outlined"
                  color="secondary"
                  sx={{
                    mb: { xs: 0, xl: 2 },
                    p: { xs: "8px 18px", xl: "8px 18px" },
                    borderRadius: "50px",
                    height: "auto",
                    ml: "10px",
                  }}
                  onClick={() => setEditing(false)} // Cancels edit mode
                >
                  Cancel
                </Button>
              </>
            )}
          </Stack>
        </Box>
      </Box>
    </>
  );
}
export default Myaccount;
